import { isMobile } from '../Utils.js';

export default class ImageCreditsController {
    constructor() {
        const elements = document.querySelectorAll("img[data-credit]");
        elements.forEach((e) => {
            if (e.parentNode.closest("div.latest-news-teaser, div.vertical-card, div.horizontal-card, div.gallery-thumbs") != null)
                return;
            ImageCreditsController.createForElement(e);
        });
    }

    static createForElement(elem) {
        let { credit } = elem.dataset;
        if (credit === undefined || credit === '' || credit === null) return;
        credit = `&copy; ${credit}`;
        elem.removeAttribute('data-credit');
        const wrapper = document.createElement('div');
        wrapper.classList.add('image-credits-wrapper');
        elem.parentNode.insertBefore(wrapper, elem);
        wrapper.appendChild(elem);
        const credits = document.createElement('div');
        credits.classList.add('image-credits');
        const creditsText = document.createElement('div');
        creditsText.innerHTML = credit;
        creditsText.classList.add('image-credits-text');
        creditsText.classList.add('credits-hidden');
        credits.appendChild(creditsText);
        const image = document.createElement('img');
        image.src = '/App_Themes/sos/images/photo-camera.png';
        image.classList.add('image-credits-button');
        image.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            creditsText.classList.toggle('credits-hidden');
        });
        if (!isMobile()) {
            image.addEventListener('mouseover', () => {
                creditsText.classList.remove('credits-hidden');
            });
            image.addEventListener('mouseout', () => {
                creditsText.classList.add('credits-hidden');
            });
        }
        credits.appendChild(image);
        wrapper.appendChild(credits);
        ImageCreditsController.addChildClasses(wrapper);
    }
    
    static createForElementInline(elem) {
        let { credit } = elem.dataset;
        if (credit === undefined || credit === '' || credit === null) return;
        credit = `&copy; ${credit}`;
        elem.removeAttribute('data-credit');
        elem.classList.add('image-credits-wrapper');
        const credits = document.createElement('div');
        credits.classList.add('image-credits');
        const creditsText = document.createElement('div');
        creditsText.innerHTML = credit;
        creditsText.classList.add('image-credits-text');
        creditsText.classList.add('credits-hidden');
        credits.appendChild(creditsText);
        const image = document.createElement('img');
        image.src = '/App_Themes/sos/images/photo-camera.png';
        image.classList.add('image-credits-button');
        image.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            creditsText.classList.toggle('credits-hidden');
        });
        if (!isMobile()) {
            image.addEventListener('mouseover', () => {
                creditsText.classList.remove('credits-hidden');
            });
            image.addEventListener('mouseout', () => {
                creditsText.classList.add('credits-hidden');
            });
        }
        credits.appendChild(image);
        elem.appendChild(credits);
        //elem.style.display = 'inherit';
        ImageCreditsController.addChildClasses(elem);
    }    

    static addChildClasses(wrapper){
        const classList = wrapper.firstElementChild.classList;
        if(classList.contains('visible-xs')) wrapper.classList.add('visible-xs');
        if(classList.contains('hidden-xs')) wrapper.classList.add('hidden-xs');
    }

    static init() {
        document.addEventListener('DOMContentLoaded', function(){
            new ImageCreditsController(); // eslint-disable-line no-new
        });
    }
}
